import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';

import * as yup from 'yup';

/** Converter events invertion settings */
export interface ConverterInvertEventsInterface {
  /** Other controller events invertion flag */
  controller?: boolean;
  /** Manual open events invertion flag */
  manualOpen?: boolean;
}

/** Converter events invertion settings - DTO schema */
export const ConverterInvertEventsDto = SerdeDtoClass.create<ConverterInvertEventsInterface>(PacsDtoKeysEnum.CONVERTER_INVERT_EVENTS_DTO, {
  controller: {
    optional: true,
    default: false,
    label: 'Инверсия контроллера',
    serializer: yup.boolean(),
  },
  manualOpen: {
    optional: true,
    default: false,
    label: 'Инверсия кнопки',
    serializer: yup.boolean(),
  },
});
